/* 🎯 shared recovery profit target — losses back + X% on a recovery win.
   User-selectable 0% / 5% / 10% (June 2026 request). Default 5%. */
export const RECOV_TARGETS = [0, 0.05, 0.10];

export const getRecovTarget = () => {
  try {
    const raw = localStorage.getItem("vts_recov_target");
    if (raw === null || raw === "") return 0.05; // Number(null) === 0 would silently pick 0%
    const v = Number(raw);
    return RECOV_TARGETS.includes(v) ? v : 0.05;
  } catch {
    return 0.05;
  }
};

export const setRecovTarget = (t) => {
  try { localStorage.setItem("vts_recov_target", String(t)); } catch { /* storage unavailable */ }
};

export const RISK_WARNING = "Stakes increase after each loss. Depth does not change the odds. A long losing streak can lose a large part or all of your balance. Real-money mode can lose your whole stake.";

export const LADDER_PAUSE_MSG = "Bot paused after a full losing streak. Review before restarting.";
